// @ts-nocheck
import React, { useState, useEffect } from 'react'
import { IconInfoError } from '../../components/Icons'
import {
	Button,
	DatePicker,
	Input,
	RedesignDropdown,
} from '../../components/StyledComponents'
import UploadBox from '../../components/features/UploadBox'
import { Title } from '../../components/layout/Title'
import { Stepper } from '../../components/features/Stepper'
import { Body } from '../../components/layout/Body'
import { TextArea } from '../../components/ui/TextArea'
import { BackArrow } from '../../components/Icons'
import Store from '../../store/Store'
import { bookingStepLabels } from './bookingStepLabels'
import {Page} from '../../components/ui/Page'

// MOCK: coordinate systems + GCP upload are UI-only for now (not sent to the backend)
const coordinateSystems = [
	{ code: 'EPSG:4326', name: 'EPSG-Code 4326', description: '(WGS 84)' },
	{ code: 'EPSG:31255', name: 'EPSG-Code 31255', description: '(Gauß-Krüger M31)' },
]

const gcpSamples = {
	'EPSG:4326': [
		['GCP1', '14.285830', '48.306940', '268.45'],
		['GCP2', '14.287120', '48.307510', '269.10'],
		['GCP3', '14.286410', '48.305880', '267.92'],
		['GCP4', '14.284950', '48.306320', '268.03'],
	],
	'EPSG:31255': [
		['GCP1', '70531.42', '351248.17', '268.45'],
		['GCP2', '70626.88', '351311.95', '269.10'],
		['GCP3', '70574.05', '351130.62', '267.92'],
		['GCP4', '70465.73', '351179.40', '268.03'],
	],
}

const downloadGcpSample = (code: string) => {
	const rows = [['id', 'x', 'y', 'z'], ...gcpSamples[code]]
	const csv = rows.map(r => r.join(';')).join('\n')
	const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
	const a = document.createElement('a')
	a.href = url
	a.download = `gcp-beispiel-${code.replace(':', '-')}.csv`
	a.click()
	URL.revokeObjectURL(url)
}

const BookingPage3 = () => {
	const bookingData = Store.bookingData

	const [formData, setFormData] = useState({
		name: bookingData?.name || '',
		dateFrom: bookingData?.dateFrom || null,
		dateTo: bookingData?.dateTo || null,
		information: bookingData?.information || '',
	})
	const [coordinateSystem, setCoordinateSystem] = useState(
		bookingData?.coordinateSystem || coordinateSystems[0].code
	)
	const [gcpFile, setGcpFile] = useState<{ name: string; size: number } | null>(
		bookingData?.gcpFileName ? { name: bookingData.gcpFileName, size: 0 } : null
	)
	useEffect(() => {
		setFormData({
			name: bookingData?.name || '',
			dateFrom: bookingData?.dateFrom || null,
			dateTo: bookingData?.dateTo || null,
			information: bookingData?.information || '',
		})
	}, [
		bookingData?.name,
		bookingData?.dateFrom,
		bookingData?.dateTo,
		bookingData?.information,
	])
	const [errors, setErrors] = useState({
		name: false,
		dateRange: false,
		dateRangeText: '',
	})

	if (!bookingData) return null

	const onDateFilter = value => {
		const from = value?.startDate
			? new Date(value.startDate).toISOString().split('T')[0]
			: null

		const to = value?.endDate
			? new Date(value.endDate).toISOString().split('T')[0]
			: null

		setFormData(prev => ({
			...prev,
			dateFrom: from,
			dateTo: to,
		}))

		setErrors(prev => ({
			...prev,
			dateRange: false,
			dateRangeText: '',
		}))
	}

	const validateForm = () => {
		const nameInvalid = !formData.name?.trim()
		const missingDates = !formData.dateFrom || !formData.dateTo

		let dateRangeInvalid = false
		let dateRangeText = ''

		if (missingDates) {
			dateRangeInvalid = true
			dateRangeText = 'Zeitraum ist erforderlich'
		} else {
			const fromDate = new Date(formData.dateFrom)
			const toDate = new Date(formData.dateTo)

			const diffMs = toDate.getTime() - fromDate.getTime()
			const diffDays = diffMs / (1000 * 60 * 60 * 24)

			if (diffDays < 7) {
				dateRangeInvalid = true
				dateRangeText = 'Der Zeitraum muss mind. 7 Tage betragen'
			}
		}

		const nextErrors = {
			name: nameInvalid,
			dateRange: dateRangeInvalid,
			dateRangeText,
		}

		setErrors(nextErrors)

		return !nameInvalid && !dateRangeInvalid
	}

	const onNext = () => {
		if (!validateForm()) return

		Store.setBookingData({
			...Store.bookingData,
			name: formData.name,
			dateFrom: formData.dateFrom,
			dateTo: formData.dateTo,
			information: formData.information,
			coordinateSystem,
			gcpFileName: gcpFile?.name ?? null,
		})

		console.log('STORE BOOKING DATA PAGE 3:', Store.bookingData)

		Store.navigate('booking/page_4')
	}

	return (
		<div className="h-full justify-center items-start flex">
			<div className="max-w-[1100px] mx-auto w-full">
				<Page>
					<Body>
						<Stepper numSteps={5} step={3} labels={bookingStepLabels} />

						<div className="w-full mx-auto px-[70px]">
							<div className="mb-10">
								<Title>Name und Zeitraum der Befliegung</Title>
							</div>

							<div className="grid grid-cols-2 gap-6 w-full mt-4 mb-14">
								<div>
									<p className="text-lg font-semibold opacity-100 text-[#333]">
										Name Ihrer Bestellung
									</p>
									<p className="my-4 text-sm text-[#666]">
										Beispiel: Flug über Gerstenfeld bei Pasching
									</p>
									<Input
										data-pw="input-booking-name"
										value={formData.name}
										onChange={value =>
											setFormData(prev => ({
												...prev,
												name: value,
											}))
										}
										placeholder="Name eingeben (max. 50 Zeichen)"
										maxLength={50}
									/>
									{errors.name && (
										<div className="inline-flex gap-2 p-1 items-center mt-2">
											<IconInfoError />
											<h6>Eingabe erforderlich</h6>
										</div>
									)}
								</div>

								<div>
									<p className="text-lg font-semibold opacity-100 text-[#333]">
										Befliegungszeitraum
									</p>
									<p className="my-4 text-sm text-[#666]">
										Der Zeitraum muss mind. 7 Tage betragen.
									</p>
									<DatePicker
										aria-label="Befliegungszeitraum"
										value={
											formData.dateFrom && formData.dateTo
												? {
													startDate: formData.dateFrom,
													endDate: formData.dateTo,
												}
												: undefined
										}
										newOnly={true}
										className="h-[48px] max-w-none"
										data-pw="date-picker-period"
										onChange={onDateFilter}
									/>
									{errors.dateRange && (
										<div className="inline-flex gap-2 p-1 items-center mt-2">
											<IconInfoError />
											<h6>{errors.dateRangeText}</h6>
										</div>
									)}
								</div>
							</div>

							<div className="grid grid-cols-2 gap-6 w-full mb-14">
								<div>
									<p className="text-lg font-semibold opacity-100 text-[#333]">
										Koordinatensystem
									</p>
									<p className="my-4 text-sm text-[#666]">
										Bezugssystem für die Auswertung und die Ground Control Points.
									</p>
									<RedesignDropdown
										data-pw="dropdown-coordinate-system"
										content={coordinateSystems.map(cs => ({
											name: cs.name,
											description: cs.description,
											_selected: cs.code === coordinateSystem,
										}))}
										onChange={items => {
											const index = items.findIndex(i => i._selected)
											if (index >= 0) setCoordinateSystem(coordinateSystems[index].code)
										}}
										placeholder="Koordinatensystem wählen"
									/>
								</div>

								<div>
									<p className="text-lg font-semibold opacity-100 text-[#333]">
										Ground Control Points
									</p>
									<p className="my-4 text-sm text-[#666]">
										Optional. CSV-Datei mit den Passpunkten (id;x;y;z) im gewählten Koordinatensystem.{' '}
										<button
											type="button"
											data-pw="button-download-gcp-sample"
											className="underline text-[#0063A3]"
											onClick={() => downloadGcpSample(coordinateSystem)}
										>
											Beispiel-CSV herunterladen
										</button>
									</p>
									{gcpFile ? (
										<div className="flex items-center justify-between rounded-xl border border-[#999] px-5 py-4">
											<span className="text-sm text-[#333] truncate">{gcpFile.name}</span>
											<button
												type="button"
												data-pw="button-remove-gcp"
												className="text-sm text-[#E1320F] ml-4"
												onClick={() => setGcpFile(null)}
											>
												Entfernen
											</button>
										</div>
									) : (
										<UploadBox
											title="GCP-Datei hochladen"
											accept=".csv,.txt"
											maxSize={5}
											multiple={false}
											onSelect={files => {
												const file = files[0]
												if (file) setGcpFile({ name: file.name, size: file.size })
											}}
										/>
									)}
								</div>
							</div>

							<div className="mt-10">
								<p className="text-lg font-semibold opacity-100 text-[#333]">
									Weitere Informationen
								</p>
								<p className="my-4 text-sm text-[#666]">
									Optional. Alle relevanten Informationen für eine erfolgreiche Befliegung.
								</p>
								<TextArea
									data-pw="textarea-additional-information"
									placeholder="Weitere Informationen eingeben. (max. 255 Zeichen)"
									value={formData.information}
									onChange={value =>
										setFormData(prev => ({
											...prev,
											information: value,
										}))
									}
									maxLength={255}
								/>
							</div>

							<div className="flex w-full justify-end">
								<div className="flex flex-row min-w-[380px] gap-4">
									<Button
										className="border border-[#E1320F] text-[#E1320F]"
										data-pw="button-back"
										onClick={() => Store.navigate('booking/page_2')}
									>
										<BackArrow /> Zurück
									</Button>

									<Button
										data-pw="button-next"
										primary
										onClick={onNext}
									>
										Weiter
									</Button>
								</div>
							</div>
						</div>
					</Body>
				</Page>
			</div>
		</div>
	)
}

export default BookingPage3
